import { useState } from "react";
import TechByTechRoleItemSubGroup from "./TechBytechRoleItemSubGroup";
import { useEffect } from "react";

export default function TechByTechRoleItemGroup({ itemGroup, setGroup }) {
  const Type = { category: 0, subcategory: 1, technology: 2 };

  return itemGroup.map((techByTechRole) => {
    if (techByTechRole.type === Type.category)
      return <label>{techByTechRole.description}</label>;
    else if (techByTechRole.type === Type.subcategory)
      return <label>{techByTechRole.description}</label>;
    else
      return (
        <div className="form-check ms-4" key={techByTechRole.id}>
          <input
            className="form-check-input"
            type="checkbox"
            value={techByTechRole.id}
            checked={techByTechRole.selected}
            onChange={() => {
              techByTechRole.selected = !techByTechRole.selected;
              setGroup([...itemGroup]);
            }}
            id={techByTechRole.id}
            name={techByTechRole.id}
          />
          <label className="form-check-label" htmlFor={techByTechRole.id}>
            {techByTechRole.description}
          </label>
        </div>
      );
  });
}
